/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class ModeloDocumento {
  constructor () {


    this.modelo_id = uuidV4()
    this.descricao = ''
    this.tp_doc = ''
    this.texto = ''
  }
}
